"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _LH55DG7Mcjs = require('./LH55DG7M.cjs');




var _PTOCUU2Dcjs = require('./PTOCUU2D.cjs');

// src/form/form-group.tsx
var TagName = "div";
var useFormGroup = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useFormGroup2({ store, ...props }) {
    props = _LH55DG7Mcjs.useGroup.call(void 0, props);
    return props;
  }
);
var FormGroup = _PTOCUU2Dcjs.forwardRef.call(void 0, function FormGroup2(props) {
  const htmlProps = useFormGroup(props);
  return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
});




exports.useFormGroup = useFormGroup; exports.FormGroup = FormGroup;
